import React, {Suspense} from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import axiosInstance from "./security/axiosInstance";

const ux = {
  loadingPpal: "modal-loading-frame",
  uxMasterPage: {
    clsNm_header: "master-header",
    clsNm_main: "master-main",
    clsNm_logo: "master-viam-logo",
    clsNm_row: "row pt-2",
    clsNm_header_text: "master-header-text",
    clsNm_status_content: "master-status-review-content",
    clsNm_sms_content: "container master-sms-content",
    clsNm_check_content: "master-check_content",
    clsNm_check_input: "master-check-input",
    clsNm_share_text:"master-share-text",
    clsNm_btn: "btn master-btn"
  },
  uxModalMail: {
    fade_show: "fade modal-backdrop show",
    fade_hide: "fade modal-backdrop hide",
    fade_modal_show: "fade modal show finish-modal",
    fade_modal_hide: "fade modal hide finish-modal",
  },
  uxMultiStep:{
    td_div: "td-div",
    td_title: "td-title",
    td_title_name: "td-title-name",
    td_title_status: "td-title-status",
    td_btn: "td-btn",
    td_tag: "td-tag",
    td_tag_approved: "td-tag.td-approved",
    td_tag_rejected: "td-tag.td-rejected",
    td_ol: "td-ol",
    td_item: "td-item",
    td_content: "td-content",
    td_content_inner: "td-content-inner",
    td_desc: "td-desc",
    td_desc_title: "td-desc-title",
    td_desc_text: "td-desc-text",
    td_desc_info: "td-desc-info",
    td_is_cancel: "is-cancel",
    active: "td-active",
    disabled: "td-disabled",
    completed: "td-completed"
  }
};
const queryParams = new URLSearchParams(window.location.search);
const token = queryParams.get("token");

ReactDOM.render(
  <Suspense fallback={<div>Loading...</div>}>
    <React.StrictMode>
      <App 
        ux = {ux} 
        axiosInstance = {axiosInstance}
        token = {token}
      />
    </React.StrictMode>
  </Suspense>,
  document.getElementById('root')
);